import { render, staticRenderFns } from "./GloveEvaluation.vue?vue&type=template&id=ec473452&scoped=true&"
import script from "./GloveEvaluation.vue?vue&type=script&lang=js&"
export * from "./GloveEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./GloveEvaluation.vue?vue&type=style&index=0&id=ec473452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec473452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec473452')) {
      api.createRecord('ec473452', component.options)
    } else {
      api.reload('ec473452', component.options)
    }
    module.hot.accept("./GloveEvaluation.vue?vue&type=template&id=ec473452&scoped=true&", function () {
      api.rerender('ec473452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Home/components/GloveEvaluation.vue"
export default component.exports